import React, { useState, useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import '@fontsource/roboto/400.css';
import Draggable from 'react-draggable';
import { FaBed, FaExclamationCircle, FaHome, FaShoppingCart, FaTruckLoading, FaUserCircle, FaVolumeUp, FaWallet } from 'react-icons/fa';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Home from './pages/Home/home';
import Allhostels from './pages/Hostels/allhostels';
import Mapmarkers from './pages/Hostels/viewallmap';
import Viewsinglehouse from './pages/Hostels/viewsinglehouse';
import Chats from './pages/Chats/chats';
import Allservices from './pages/Services/allservices';
import { primarycolor } from './pages/Utils/colors';
import Viewsinglebusiness from './pages/Services/viewsinglesbusiness';
import Viewsingleservice from './pages/Services/viewsingleservice';
import Cart from './pages/Services/cart';
import Useraccount from './pages/Account/useraccount';
import Security from './pages/Account/security';
import { getsessionuser } from './pages/Utils/sessions';
import {
    Button, Dialog, DialogContent, DialogContentText, DialogTitle, Paper,
    DialogActions, Avatar, Typography, Fade, Slide, Collapse, Divider,
    Modal
} from '@mui/material';
import Loadingspinner from './pages/Components/loading';
import Fetchmyproperties from './pages/Landlords/fetchmyproperties';
import Viewsingleproperty from './pages/Landlords/viewsingleproperty';
import Mainwallet from './pages/Wallet/mainwallet';
import Roommates from './pages/Roommates/roommates';
import Fetchmybusinesses from './pages/Businessowner/fetchmybusinesses';
import Viewmysinglebiz from './pages/Businessowner/viewmybusiness';
import Help from './pages/Help/help';
import Faqs from './pages/Help/faq\'s';
import Terms from './pages/Common/terms';
import Fetchblogs from './pages/Blog/fetchblogs';
import Viewsingleblog from './pages/Blog/viewsingleblog';
import Fetchmyblogs from './pages/Authors/fetchmyblogs';
import { googleLogout } from '@react-oauth/google';
import Eazimove from './pages/Movers/eazimove';
import SignIn from './pages/Common/login';

const BRAND = '#900f20';
const BRAND_DARK = '#670600';

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} sx={{ borderRadius: '16px', boxShadow: '0 12px 40px rgba(0,0,0,0.1)' }} />
        </Draggable>
    );
}

// Top-level nav links (no dropdown required)
const mainNavLinks = [
    { label: 'Home', icon: FaHome, path: 'home', match: ['/nav/home'] },
    { label: 'Eazihomes', icon: FaBed, path: 'hostels', match: ['/nav/hostels', '/nav/hostelsfilter'] },
    { label: 'Eaziserve', icon: FaShoppingCart, path: 'services', match: ['/nav/services'] },
    // { label: 'EaziWallet', icon: FaWallet,       path: 'mywallet', match: ['/nav/mywallet'] },
    { label: 'Eaziblog', icon: FaVolumeUp, path: 'eaziblog', match: ['/nav/eaziblog'] },
    { label: 'Eazimove', icon: FaTruckLoading, path: 'eazimove', match: ['/nav/eazimove'] },
];

const helpLinks = [
    { label: 'Contact Us', path: 'contactus', match: '/nav/contactus' },
    { label: 'Terms & Conditions', path: 'terms', match: '/nav/terms' },
];

const profileLinks = [
    { label: 'Personal Info', path: 'useraccount', match: '/nav/useraccount' },
    { label: 'My Properties', path: 'myproperties', match: '/nav/myproperties' },
    { label: 'My Services', path: 'mybusinesses', match: '/nav/mybusinesses' },
    { label: 'My Blogs', path: 'myblogs', match: '/nav/myblogs' },
    { label: 'Security', path: 'security', match: '/nav/security' },
];

// A floating dropdown panel
const DropdownMenu = ({ items, onNavigate, pathname, onSignOut, showSignOut }) => (
    <Paper
        elevation={0}
        sx={{
            position: 'absolute',
            top: 'calc(100% + 12px)',
            right: 0,
            minWidth: 220,
            borderRadius: '16px',
            border: '1px solid rgba(0,0,0,0.06)',
            boxShadow: '0 16px 48px rgba(0,0,0,0.10)',
            overflow: 'hidden',
            zIndex: 1400,
            py: 1,
            bgcolor: 'white',
        }}
    >
        {items.map((item, i) => (
            <Box
                key={i}
                onClick={() => onNavigate(item.path)}
                sx={{
                    px: 2.5, py: 1.4, cursor: 'pointer', display: 'flex', alignItems: 'center',
                    bgcolor: pathname === item.match ? 'rgba(144, 15, 32, 0.06)' : 'transparent',
                    color: pathname === item.match ? BRAND : 'text.primary',
                    fontWeight: pathname === item.match ? 700 : 500,
                    fontSize: '0.9rem',
                    transition: 'all 0.2s ease',
                    '&:hover': { bgcolor: 'rgba(144, 15, 32, 0.04)', color: BRAND }
                }}
            >
                {item.label}
            </Box>
        ))}
        {showSignOut && (
            <>
                <Divider sx={{ my: 1 }} />
                <Box
                    onClick={onSignOut}
                    sx={{
                        px: 2.5, py: 1.4, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 1.5,
                        color: '#d32f2f', fontWeight: 600, fontSize: '0.9rem',
                        transition: 'all 0.2s ease',
                        '&:hover': { bgcolor: 'rgba(211, 47, 47, 0.05)' }
                    }}
                >
                    <PowerSettingsNewIcon fontSize="small" />
                    Sign Out
                </Box>
            </>
        )}
    </Paper>
);

export default function Topnav() {
    const tuser = getsessionuser();
    const [refresh, setrefresh] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [user, setuser] = useState(tuser);
    const pathname = location?.pathname;

    const [logoutdialog, setlogoutdialog] = useState(false);
    const [loading, setloading] = useState(false);
    const [mobileOpen, setmobileOpen] = useState(false);
    const [helpOpen, sethelpOpen] = useState(false);
    const [profileOpen, setprofileOpen] = useState(false);
    const [scrolled, setscrolled] = useState(false);
    const [showlogin, setshowlogin] = useState(false);

    // Mobile accordion states
    const [mobileHelpOpen, setmobileHelpOpen] = useState(false);
    const [mobileProfileOpen, setmobileProfileOpen] = useState(false);

    const helpRef = useRef(null);
    const profileRef = useRef(null);

    useEffect(() => {
        const userobject = sessionStorage?.getItem("user");
        if (userobject) {
            const object = JSON.parse(userobject);
            if (object?.username !== user?.username) setuser(object);
        }
    }, [refresh]);

    useEffect(() => {
        const handleScroll = () => setscrolled(window.scrollY > 10);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Close dropdowns when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (helpRef.current && !helpRef.current.contains(e.target)) sethelpOpen(false);
            if (profileRef.current && !profileRef.current.contains(e.target)) setprofileOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Close mobile menu on route change
    useEffect(() => { setmobileOpen(false); }, [pathname]);

    const onlogout = (e) => {
        e.preventDefault();
        setlogoutdialog(false);
        setloading(true);
        setuser(null);
        setTimeout(() => {
            setrefresh(!refresh);
            setuser(null);
            setloading(false);
            navigate("home", { replace: true });
            localStorage?.removeItem("user");
            sessionStorage?.removeItem("user");
            sessionStorage?.removeItem("cart");
            sessionStorage?.removeItem("house");
            googleLogout();
        }, 2000);
    };

    const onrefresh = () => setrefresh(!refresh);

    const navTo = (path) => {
        navigate(path);
        sethelpOpen(false);
        setprofileOpen(false);
    };
    const onsuccesslogin = () => {
        setshowlogin(false);
        setrefresh(!refresh);
        setTimeout(() => {
            window.location.reload();
        }, 200);
    }


    const onSignIn = () => {
        if (user?.username) {
            navigate('useraccount')
        } else {
            setshowlogin(true)
        }
    }

    const isActive = (matches) => matches.some(m => pathname === m || pathname?.startsWith(m));

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#f8f9fa' }}>
            <Modal open={showlogin} onClose={() => setshowlogin(false)}>
                <SignIn onsuccesslogin={onsuccesslogin} />
            </Modal>
            {/* Logout Dialog */}
            <Dialog
                open={logoutdialog}
                onClose={() => setlogoutdialog(false)}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 400 }}
            >
                <DialogTitle style={{ cursor: 'move', fontWeight: 'bold', paddingTop: '24px' }} id="draggable-dialog-title">
                    Confirm Sign Out
                </DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ color: 'text.secondary', fontSize: '15px' }}>
                        Are you sure you want to log out? You'll need to sign in again to access your account.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ padding: '16px 24px', paddingBottom: '24px', gap: 1 }}>
                    <Button disableElevation onClick={() => setlogoutdialog(false)} sx={{ color: 'text.secondary', textTransform: 'none', fontWeight: 600, borderRadius: '8px', px: 3 }}>
                        Cancel
                    </Button>
                    <Button
                        disableElevation onClick={onlogout} variant="contained"
                        sx={{
                            background: 'linear-gradient(90deg, #d32f2f 0%, #c62828 100%)', color: 'white',
                            textTransform: 'none', fontWeight: 600, borderRadius: '8px', px: 3,
                            '&:hover': { background: '#b71c1c' }
                        }}
                    >
                        Log Out
                    </Button>
                </DialogActions>
            </Dialog>

            <CssBaseline />
            {loading && <Loadingspinner />}

            {/* ═══ TOP NAVIGATION BAR ═══ */}
            <Box
                component="nav"
                sx={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1300,
                    width: '100%',
                    backdropFilter: 'blur(16px)',
                    WebkitBackdropFilter: 'blur(16px)',
                    backgroundColor: scrolled ? 'rgba(255,255,255,0.92)' : 'rgba(255,255,255,0.85)',
                    borderBottom: scrolled ? '1px solid rgba(0,0,0,0.06)' : '1px solid rgba(0,0,0,0.03)',
                    boxShadow: scrolled ? '0 4px 24px rgba(0,0,0,0.06)' : 'none',
                    transition: 'all 0.3s ease',
                }}
            >
                <Box sx={{ maxWidth: '100%', px: { xs: 2, md: 4 }, height: 68, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

                    {/* ── Logo ── */}
                    <Box
                        onClick={() => navigate('home')}
                        sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer', textDecoration: 'none', flexShrink: 0 }}
                    >
                        <Box sx={{
                            width: 36, height: 36, borderRadius: '10px',
                            background: `linear-gradient(135deg, ${BRAND} 0%, ${BRAND_DARK} 100%)`,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            boxShadow: '0 4px 12px rgba(103, 6, 0, 0.25)',
                        }}>
                            <Typography sx={{ color: 'white', fontWeight: 900, fontSize: 20, lineHeight: 1 }}>E</Typography>
                        </Box>
                        <Typography sx={{ fontWeight: 800, fontSize: '1.2rem', color: BRAND_DARK, letterSpacing: '-0.5px' }}>
                            Eazistey
                        </Typography>
                    </Box>

                    {/* ── Desktop Links ── */}
                    <Box sx={{ display: { xs: 'none', lg: 'flex' }, alignItems: 'center', gap: 0.5 }}>
                        {mainNavLinks.map((link) => {
                            const active = isActive(link.match);
                            return (
                                <Box
                                    key={link.path}
                                    onClick={() => navigate(link.path)}
                                    sx={{
                                        display: 'flex', alignItems: 'center', gap: 1,
                                        px: 1.8, py: 1.1, borderRadius: '10px', cursor: 'pointer',
                                        fontSize: '0.88rem', fontWeight: active ? 700 : 500,
                                        color: active ? BRAND : '#4a4a4a',
                                        bgcolor: active ? 'rgba(144,15,32,0.07)' : 'transparent',
                                        transition: 'all 0.2s ease',
                                        '&:hover': { bgcolor: 'rgba(144,15,32,0.05)', color: BRAND },
                                    }}
                                >
                                    <link.icon size={15} />
                                    {link.label}
                                </Box>
                            );
                        })}

                        {/* Help dropdown */}
                        <Box ref={helpRef} sx={{ position: 'relative' }}>
                            <Box
                                onClick={() => { sethelpOpen(!helpOpen); setprofileOpen(false); }}
                                sx={{
                                    display: 'flex', alignItems: 'center', gap: 1,
                                    px: 1.8, py: 1.1, borderRadius: '10px', cursor: 'pointer',
                                    fontSize: '0.88rem', fontWeight: isActive(['/nav/contactus', '/nav/faqs', '/nav/terms']) ? 700 : 500,
                                    color: isActive(['/nav/contactus', '/nav/faqs', '/nav/terms']) ? BRAND : '#4a4a4a',
                                    bgcolor: isActive(['/nav/contactus', '/nav/faqs', '/nav/terms']) ? 'rgba(144,15,32,0.07)' : 'transparent',
                                    transition: 'all 0.2s ease',
                                    '&:hover': { bgcolor: 'rgba(144,15,32,0.05)', color: BRAND },
                                }}
                            >
                                <FaExclamationCircle size={15} />
                                Help
                                <KeyboardArrowDownIcon sx={{ fontSize: 18, transition: 'transform 0.2s', transform: helpOpen ? 'rotate(180deg)' : 'none' }} />
                            </Box>
                            {helpOpen && (
                                <DropdownMenu items={helpLinks} onNavigate={navTo} pathname={pathname} />
                            )}
                        </Box>
                    </Box>

                    {/* ── Right Side: Profile / Auth ── */}
                    <Box sx={{ display: { xs: 'none', lg: 'flex' }, alignItems: 'center', gap: 1.5 }}>
                        {user ? (
                            <Box ref={profileRef} sx={{ position: 'relative' }}>
                                <Box
                                    onClick={() => { setprofileOpen(!profileOpen); sethelpOpen(false); }}
                                    sx={{
                                        display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer',
                                        pl: 1.5, pr: 2, py: 1, borderRadius: '12px', border: '1px solid rgba(0,0,0,0.06)',
                                        bgcolor: profileOpen ? 'rgba(144,15,32,0.04)' : 'white',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                                        transition: 'all 0.2s ease',
                                        '&:hover': { borderColor: 'rgba(144,15,32,0.2)', boxShadow: '0 4px 16px rgba(0,0,0,0.06)' }
                                    }}
                                >
                                    <Avatar sx={{ width: 32, height: 32, bgcolor: BRAND, fontSize: 14, fontWeight: 700 }}>
                                        {user?.username?.charAt(0)?.toUpperCase()}
                                    </Avatar>
                                    <Box sx={{ maxWidth: 120 }}>
                                        <Typography variant="body2" noWrap sx={{ fontWeight: 700, color: '#1a1a1a', lineHeight: 1.2, maxWidth: 110 }}>{user?.username}</Typography>
                                        <Typography variant="caption" noWrap sx={{ color: 'text.disabled', display: 'block', maxWidth: 110 }}>{user?.email}</Typography>
                                    </Box>
                                    <KeyboardArrowDownIcon sx={{ fontSize: 18, color: 'text.disabled', transition: 'transform 0.2s', transform: profileOpen ? 'rotate(180deg)' : 'none' }} />
                                </Box>
                                {profileOpen && (
                                    <DropdownMenu
                                        items={profileLinks}
                                        onNavigate={navTo}
                                        pathname={pathname}
                                        showSignOut={true}
                                        onSignOut={() => { setprofileOpen(false); setlogoutdialog(true); }}
                                    />
                                )}
                            </Box>
                        ) : (
                            <Button
                                onClick={() => onSignIn()}
                                variant="contained"
                                disableElevation
                                startIcon={<FaUserCircle />}
                                sx={{
                                    borderRadius: '12px', px: 3, py: 1.2, textTransform: 'none', fontWeight: 700,
                                    background: `linear-gradient(90deg, ${BRAND} 0%, ${BRAND_DARK} 100%)`,
                                    boxShadow: '0 4px 16px rgba(103, 6, 0, 0.2)',
                                    '&:hover': { boxShadow: '0 6px 20px rgba(103, 6, 0, 0.3)', transform: 'translateY(-1px)' },
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                Sign In
                            </Button>
                        )}
                    </Box>

                    {/* ── Mobile Hamburger ── */}
                    <IconButton
                        onClick={() => setmobileOpen(!mobileOpen)}
                        sx={{ display: { xs: 'flex', lg: 'none' }, ml: 1, bgcolor: 'rgba(0,0,0,0.04)', borderRadius: '10px' }}
                    >
                        {mobileOpen ? <CloseIcon /> : <MenuIcon />}
                    </IconButton>
                </Box>

                {/* ── Mobile Menu ── */}
                <Slide direction="down" in={mobileOpen} mountOnEnter unmountOnExit>
                    <Box
                        sx={{
                            display: { xs: 'block', lg: 'none' },
                            px: 2, pb: 3,
                            borderTop: '1px solid rgba(0,0,0,0.05)',
                            bgcolor: 'rgba(255,255,255,0.97)',
                            backdropFilter: 'blur(12px)',
                            maxHeight: '80vh',
                            overflowY: 'auto',
                        }}
                    >
                        {/* User header on mobile */}
                        {user && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 2, mb: 1, bgcolor: 'rgba(144,15,32,0.03)', borderRadius: '14px', mt: 2 }}>
                                <Avatar sx={{ width: 40, height: 40, bgcolor: BRAND, fontWeight: 700 }}>
                                    {user?.username?.charAt(0)?.toUpperCase()}
                                </Avatar>
                                <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 700 }}>{user?.username}</Typography>
                                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>{user?.email}</Typography>
                                </Box>
                            </Box>
                        )}

                        {/* Main links */}
                        {mainNavLinks.map((link) => {
                            const active = isActive(link.match);
                            return (
                                <Box
                                    key={link.path}
                                    onClick={() => navigate(link.path)}
                                    sx={{
                                        display: 'flex', alignItems: 'center', gap: 2, px: 2, py: 1.5, borderRadius: '12px',
                                        cursor: 'pointer', my: 0.5, fontWeight: active ? 700 : 500,
                                        fontSize: '0.95rem',
                                        color: active ? BRAND : '#2d3436',
                                        bgcolor: active ? 'rgba(144,15,32,0.06)' : 'transparent',
                                        '&:hover': { bgcolor: 'rgba(0,0,0,0.03)' }
                                    }}
                                >
                                    <link.icon size={18} color={active ? BRAND : '#757575'} />
                                    {link.label}
                                </Box>
                            );
                        })}

                        <Divider sx={{ my: 1.5 }} />

                        {/* Help Accordion */}
                        <Box
                            onClick={() => setmobileHelpOpen(!mobileHelpOpen)}
                            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, borderRadius: '12px', cursor: 'pointer', '&:hover': { bgcolor: 'rgba(0,0,0,0.03)' } }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, fontWeight: 500, fontSize: '0.95rem', color: '#2d3436' }}>
                                <FaExclamationCircle size={18} color="#757575" /> Help & Support
                            </Box>
                            <KeyboardArrowDownIcon sx={{ fontSize: 20, color: 'text.disabled', transition: 'transform 0.2s', transform: mobileHelpOpen ? 'rotate(180deg)' : 'none' }} />
                        </Box>
                        <Collapse in={mobileHelpOpen}>
                            <Box sx={{ pl: 4, pb: 1 }}>
                                {helpLinks.map(item => (
                                    <Box key={item.path} onClick={() => navigate(item.path)} sx={{ py: 1.2, px: 2, cursor: 'pointer', borderRadius: '10px', fontWeight: pathname === item.match ? 700 : 500, color: pathname === item.match ? BRAND : 'text.secondary', '&:hover': { color: BRAND } }}>
                                        {item.label}
                                    </Box>
                                ))}
                            </Box>
                        </Collapse>

                        {/* Profile Accordion (only if logged in) */}
                        {user && (
                            <>
                                <Box
                                    onClick={() => setmobileProfileOpen(!mobileProfileOpen)}
                                    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, borderRadius: '12px', cursor: 'pointer', '&:hover': { bgcolor: 'rgba(0,0,0,0.03)' } }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, fontWeight: 500, fontSize: '0.95rem', color: '#2d3436' }}>
                                        <FaUserCircle size={18} color="#757575" /> My Account
                                    </Box>
                                    <KeyboardArrowDownIcon sx={{ fontSize: 20, color: 'text.disabled', transition: 'transform 0.2s', transform: mobileProfileOpen ? 'rotate(180deg)' : 'none' }} />
                                </Box>
                                <Collapse in={mobileProfileOpen}>
                                    <Box sx={{ pl: 4, pb: 1 }}>
                                        {profileLinks.map(item => (
                                            <Box key={item.path} onClick={() => navigate(item.path)} sx={{ py: 1.2, px: 2, cursor: 'pointer', borderRadius: '10px', fontWeight: pathname === item.match ? 700 : 500, color: pathname === item.match ? BRAND : 'text.secondary', '&:hover': { color: BRAND } }}>
                                                {item.label}
                                            </Box>
                                        ))}
                                    </Box>
                                </Collapse>

                                <Divider sx={{ my: 1.5 }} />
                                <Box
                                    onClick={() => { setmobileOpen(false); setlogoutdialog(true); }}
                                    sx={{ display: 'flex', alignItems: 'center', gap: 2, px: 2, py: 1.5, borderRadius: '12px', cursor: 'pointer', color: '#d32f2f', fontWeight: 600, '&:hover': { bgcolor: 'rgba(211,47,47,0.05)' } }}
                                >
                                    <PowerSettingsNewIcon fontSize="small" /> Sign Out
                                </Box>
                            </>
                        )}

                        {!user && (
                            <Button
                                onClick={() => navigate('useraccount')}
                                fullWidth variant="contained" disableElevation
                                sx={{ mt: 2, borderRadius: '14px', py: 1.5, textTransform: 'none', fontWeight: 700, background: `linear-gradient(90deg, ${BRAND} 0%, ${BRAND_DARK} 100%)` }}
                            >
                                Sign In / Register
                            </Button>
                        )}
                    </Box>
                </Slide>
            </Box>

            {/* ═══ PAGE CONTENT ═══ */}
            <Box component="main" sx={{ flexGrow: 1 }}>
                <Routes>
                    <Route path="/" exact element={<Navigate replace to="/nav/home" />} />
                    <Route path="/home" exact element={<Home onrefresh={onrefresh} />} />
                    <Route path="/hostels" exact element={<Allhostels />} />
                    <Route path="/hostelsfilter" exact element={<Allhostels />} />
                    <Route path="/viewallmarkers" exact element={<Mapmarkers />} />
                    <Route path="/viewsinglehouse/:houseId" element={<Viewsinglehouse onrefresh={onrefresh} />} exact />
                    <Route path="/chats" element={<Chats />} exact />
                    <Route path="/services" element={<Allservices />} exact />
                    <Route path="/viewsinglebusiness/:businessemail" element={<Viewsinglebusiness onrefresh={onrefresh} />} exact />
                    <Route path="/viewsingleservice" element={<Viewsingleservice onrefresh={onrefresh} />} exact />
                    <Route path="/cart" element={<Cart />} exact />
                    <Route path="/useraccount" element={<Useraccount onrefresh={onrefresh} />} exact />
                    <Route path="/security" element={<Security onrefresh={onrefresh} />} exact />
                    <Route path="/myproperties" element={<Fetchmyproperties onrefresh={onrefresh} />} exact />
                    <Route path="/viewsingleproperty/:propertyId" element={<Viewsingleproperty onrefresh={onrefresh} />} exact />
                    <Route path="/mywallet" element={<Mainwallet onrefresh={onrefresh} />} exact />
                    <Route path="/roommates" element={<Roommates onrefresh={onrefresh} />} exact />
                    <Route path="/eaziblog" element={<Fetchblogs onrefresh={onrefresh} />} exact />
                    <Route path="/viewsingleblog/:blogId" element={<Viewsingleblog onrefresh={onrefresh} />} exact />
                    <Route path="/myblogs" element={<Fetchmyblogs onrefresh={onrefresh} />} exact />
                    <Route path="/eazimove" element={<Eazimove onrefresh={onrefresh} />} exact />
                    <Route path="/mybusinesses" element={<Fetchmybusinesses onrefresh={onrefresh} />} exact />
                    <Route path="/viewmysinglebiz/:businessId" element={<Viewmysinglebiz />} exact />
                    <Route path="/contactus" element={<Help onrefresh={onrefresh} />} exact />
                    <Route path="/faqs" element={<Faqs />} exact />
                    <Route path="/terms" element={<Terms />} exact />
                </Routes>
            </Box>
        </Box>
    );
}